import { useEffect, useState } from "react";
import classNames from "classnames";
import { Typography } from "components/atoms";
import { StudyPlannerScheduleDetailedCard } from "../StudyPlannerScheduleDetailedCard";
import "./index.scss";
import { formatDateDuration } from "utils/functions/formatDateDuration";
import dayjs from "dayjs";

interface IProps {
  cardData: any;
  theme: "light" | "dark";
  day: any;
}

export const StudyPlannerScheduleCard = ({ cardData, theme, day }: IProps) => {
  const [showMore, setShowMore] = useState(false);

  const handleToggleView = () => {
    setShowMore(true);
  };

  useEffect(() => {
    if (cardData) {
      setShowMore(false);
    }
  }, [cardData]);

  return showMore ? (
    <StudyPlannerScheduleDetailedCard
      theme={theme}
      id={cardData.StudyPlannerEventId}
      toggleView={setShowMore}
      editable={cardData.Editable}
    />
  ) : (
    <div
      className={classNames({
        "schedule-section": true,
        "class-segment-tile": cardData.EventType === "ClassSegment" || cardData.EventType === "TopicFocusSegment",
        "diagnostic-exam": cardData.EventType === "Diagnostic",
        "test-segment-tile": cardData.EventType === "TestSegment",
        "homework-tile": cardData.EventType === "Homework",
        "Test-day-tile": cardData.EventType === "TestDay",
        "additional-tile":
          cardData.EventType !== "Homework" &&
          cardData.EventType !== "Diagnostic" &&
          cardData.EventType !== "TestSegment" &&
          cardData.EventType !== "ClassSegment" &&
          cardData.EventType !== "TopicFocusSegment" &&
          cardData.EventType !== "TestDay" &&
          cardData.EventType !== "Prework",
        "isPastLightTheme": dayjs().isAfter(day) && theme === "light",
        "isPastDarkTheme": dayjs().isAfter(day) && theme === "dark"
      })}
      onClick={() =>
        cardData.StudyPlannerEventId !== null &&
        cardData.EventType !== "TestSegment" &&
        handleToggleView()
      }
    >
      <div className="left-content-section">
        <Typography
          label={cardData.Title}
          variant="h10Bold"
          styles="card-title"
        />
        <Typography
          label={cardData.EventType.replace(/([A-Z])/g, " $1").trim()}
          variant="h10Book"
          styles="card-type"
        />
      </div>
      {cardData.EventType === "Homework" ||
      cardData.EventType === "Diagnostic" ||
      cardData.EventType === "Prework" ? (
        <div className="right-content-section">
          <Typography
            label={
              cardData.TimeEstimate === 0 || cardData.TimeEstimate === null
                ? "0 min"
                : formatDateDuration(cardData.TimeEstimate)
            }
            variant="h8Bold"
            styles="title-typography-custom-style"
          />
          <Typography
            label={`${cardData.GroupingItemsCountComplete}/${cardData.GroupingItemsCount} Completed`}
            variant="h8Bold"
            styles="description-typography-custom-style"
          />
        </div>
      ) : null}
    </div>
  );
};
